import { Component, OnInit, Input, Optional, Self, ElementRef } from '@angular/core';
import { MatLegacyFormFieldControl as MatFormFieldControl } from '@angular/material/legacy-form-field';
import { ControlValueAccessor, UntypedFormGroup, NgControl, UntypedFormBuilder, UntypedFormArray, UntypedFormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { NumberCoordinate, LotteryParam, LotteryParamOption, Point, Option } from '../../lottoloca-commom/lottery-modex';
import { FocusMonitor } from '@angular/cdk/a11y';
import { List } from 'linqts';
import { EventEmitter } from 'events';

@Component({
  selector: 'lottery-params',
  templateUrl: './lottery-params.component.html',
  styleUrls: ['./lottery-params.component.css'],
  providers: [

    { provide: MatFormFieldControl, useExisting: LotteryParamsComponent },

  ],
  host: {
    '[class.floating]': 'shouldLabelFloat',
    '[id]': 'id',
    '[attr.aria-describedby]': 'describedBy',
  }
})
export class LotteryParamsComponent implements MatFormFieldControl<LotteryParam[]>, ControlValueAccessor, OnInit {

  static nextId = 0;
  parts: UntypedFormGroup;
  stateChanges = new Subject<void>();
  focused = false;
  //ngControl = null;
  errorState = false;
  controlType = 'lottery-params';
  id = `lottery-params-${LotteryParamsComponent.nextId++}`;
  describedBy = '';
  _isReady: boolean = false;

  private onChange: (value: any, event: EventEmitter) => void;
  _value: LotteryParam[];
  _items: UntypedFormArray;


  constructor(@Optional() @Self() public ngControl: NgControl,
    fb: UntypedFormBuilder,
    private fm: FocusMonitor,
    private elRef: ElementRef<HTMLElement>,
    private formBuilder: UntypedFormBuilder) {

    // Setting the value accessor directly (instead of using
    // the providers) to avoid running into a circular import.
    if (this.ngControl != null) { this.ngControl.valueAccessor = this; }

    this.parts = fb.group({
      textValue: ''
    });

    fm.monitor(elRef.nativeElement, true).subscribe(origin => {
      this.focused = !!origin;
      this.stateChanges.next();
    });
  }


  writeValue(obj: LotteryParam[]): void {

    this.value = obj;
  }
  registerOnChange(onChange: (value: any, event: EventEmitter) => void): void {

    this.onChange = onChange;
  }



  registerOnTouched(fn: any): void {
    //throw new Error("Method not implemented.");
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;

    if (isDisabled) {
      this.parts.get("textValue").disable();
    }
    else {
      this.parts.get("textValue").enable();
    }
  }


  get empty() {
    const { value: { textValue } } = this.parts;

    return !textValue;
  }

  get shouldLabelFloat() { return this.focused || !this.empty; }

  @Input()
  get placeholder(): string { return this._placeholder; }
  set placeholder(value: string) {
    this._placeholder = value;
    this.stateChanges.next();
  }
  private _placeholder: string;

  @Input()
  get required(): boolean { return this._required; }
  set required(value: boolean) {
    this._required = coerceBooleanProperty(value);
    this.stateChanges.next();
  }
  private _required = false;

  @Input()
  get disabled(): boolean { return this._disabled; }
  set disabled(value: boolean) {
    this._disabled = coerceBooleanProperty(value);
    this.stateChanges.next();
  }
  private _disabled = false;

  @Input()
  get value(): LotteryParam[] | null {


    return this._value;

  }

  set value(value: LotteryParam[] | null) {

    if (value == null) {
      this._value = [];
    }
    else {

      this._value = value;
    }

    this.updateGui();

    this.stateChanges.next();
  }

  ngOnDestroy() {
    this.stateChanges.complete();
    this.fm.stopMonitoring(this.elRef.nativeElement);
  }

  setDescribedByIds(ids: string[]) {
    this.describedBy = ids.join(' ');
  }

  onContainerClick(event: MouseEvent) {
    if ((event.target as Element).tagName.toLowerCase() != 'input') {
      this.elRef.nativeElement.querySelector('input')!.focus();
    }
  }



  //******************************* */

  public _indexes: any[] = [];

  public updateGui(): any {

    let items: Array<UntypedFormGroup> = [];

    this.value.forEach(x => {

      items.push(this.createItem(x.description, x.options))

    });

    this.orderForm = this.formBuilder.group({
      items: this.formBuilder.array(items)
    });

    this._items = this.orderForm.get("items") as UntypedFormArray;

    this.orderForm
      .valueChanges
      .subscribe(() => {

        this.propagateChanges();
      }
      );

  }

  public showValue() {

  }

  public onChangeCoordinate(X: number, Y: number, value: any) {


  }

  public addParameter() {


    this.addItem();


  }

  addItem(): void {

    this.items = this.orderForm.get('items') as UntypedFormArray;

    this.items.push(this.createItem('newDescription', []));

  }

  public propagateChanges() {

    let values: LotteryParam[] = [];

    try {

      this.orderForm.value.items.forEach(element => {

        let params = element.textOptions.trim().split('\n');

        let options: Option[] = [];

        params.forEach(param => {
          let parts = param.split("|");
          let description = parts[0];

          let coordinates: Point[] = [];

          for (let i = 1; i < parts.length; i++) {

            let regex = /\(([0-9\.]+)\;([0-9\.]+)\)/g
            let match = regex.exec(parts[i])

            let point: Point = { X: Number(match[1].valueOf()), Y: Number(match[2].valueOf()) };

            coordinates.push(point);

          }



          let option: Option = { description: description, coordinates: coordinates };

          options.push(option);

        });

        let lotteryParam: LotteryParam = { description: element.description, options: options };

        values.push(lotteryParam);


      });



    } catch (error) {

    }

    this._value = values;

    if (this.onChange != null) {
      this.onChange(this.value, null)
    }
  }

  public showValues() {

  }


  createItem(description: string, options: LotteryParamOption[]): UntypedFormGroup {


    if (options == null) {
      options = [];
    }

    // let formOptions:Array<FormGroup> = [];

    // options.forEach(option=>
    //   {

    //     formOptions.push(this.formBuilder.group(option));
    //   });

    let text = "";

    options.forEach(option => {

      text += option.description
      option.coordinates.forEach(coordinate => {
        text += "|" + `(${coordinate.X};${coordinate.Y})`
      });

      text += "\n";
    });

    return this.formBuilder.group({
      description: description,
      textOptions: text,
      options: new UntypedFormControl(options)
    });


  }

  orderForm: UntypedFormGroup;
  items: UntypedFormArray;


  ngOnInit() {
    this.updateGui();
  }

  public remove(index: number) {

    this._items = this.orderForm.get("items") as UntypedFormArray;

    this._items.removeAt(index);

  }
}
